export default "__VITE_ASSET__DrByCVGc__"